<script setup lang="ts">
import NotificationMessage from '@/components/common/NotificationMessage.vue';
import LoggedOutFrame from '@/layouts/LoggedOutFrame.vue';
import { PopUpSize } from '@/models/pop-up-size.enum';
import { PopUpType } from '@/models/pop-up-type.enum';
import { NotificationType } from '@onrunning/backstage-models';
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { UsersService } from '../services/users.service';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const notification = ref('');
const usersService = new UsersService();
const error = ref<string | undefined>(undefined);
const isLoading = ref(false);

onMounted(() => {
  unsubscribePaymentsEmail();
});

async function unsubscribePaymentsEmail() {
  isLoading.value = true;
  error.value = undefined;

  try {
    const response = await usersService.unsubscribeEmail(
      route.params.token as string,
      route.params.userId as string,
      NotificationType.Payment,
    );

    if (response.isValid() && response.model) {
      notification.value = t('paymentEmailSubscription.success_message');
    } else {
      error.value = t('paymentEmailSubscription.error_message');
    }
  } catch (e: any) {
    error.value = t(e.message).toString();
  }

  isLoading.value = false;
}

function closePopup() {
  router.replace('/');
}
</script>
<template>
  <LoggedOutFrame
    :header="t('paymentEmailSubscription.header')"
    :background-image-url="t('paymentEmailSubscription.background_image_url')">
    <NotificationMessage
      v-if="notification"
      :size="PopUpSize.Medium"
      :type="PopUpType.Success"
      :title="notification"
      v-on:close="closePopup()">
    </NotificationMessage>
    <NotificationMessage
      v-if="error"
      :size="PopUpSize.Medium"
      :type="PopUpType.Error"
      :title="error"
      v-on:close="closePopup()">
    </NotificationMessage>
  </LoggedOutFrame>
</template>

<style lang="scss" scoped></style>
